





























































































































import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import { TypedGqlError } from '@/interfaces/error'

@Component({
  components: {
    AppBreadcrumbs,
    AppDialog
  }
})
export default class ChangePassword extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '设置'
    },
    {
      text: '修改密码'
    }
  ]

  valid = true
  showOldPWD = false
  showNewPWD = false
  showConfirmPWD = false

  oldPassword = ''
  newPassword = ''
  confirmPassword = ''

  confirmDialog = false
  disableConfirm = false

  rules = {
    required: (value: string) => !!value || '不能为空',
    min: (value: string) => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d\s])[A-Za-z\d\S]{8,20}$/.test(value) || '需包含数字、大小写字母和符号'
  }

  get form (): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  validate () {
    if (this.form.validate()) {
      this.save()
    }
  }

  get passwordConfirmationRule () {
    return () => (this.newPassword === this.confirmPassword) || '密码两次输入不一致'
  }

  save () {
    this.confirmDialog = true
  }

  async confirm () {
    this.disableConfirm = true
    this.confirmDialog = false
    try {
      await this.$apollo.mutate({
        mutation: gql`
          mutation {
            editSelfPassword(
              newPassword: "${this.newPassword}"
              oldPassword: "${this.oldPassword}"
            )
          }
        `
      })
      showNotification({
        msg: '密码修改成功',
        type: SnackType.Success
      })
      setTimeout(() => {
        localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE_KEY as string)
        this.$router.replace({ name: 'SignIn' })
      }, 1000)
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    } finally {
      this.disableConfirm = false
    }
  }

  clearForm () {
    this.oldPassword = ''
    this.newPassword = ''
    this.confirmPassword = ''
  }
}
